import _regeneratorRuntime from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
var _hoisted_1 = {
  key: 1,
  class: "list-content"
};
var _hoisted_2 = ["onClick"];
var _hoisted_3 = {
  class: "list_info"
};
var _hoisted_4 = {
  class: "list_type"
};
var _hoisted_5 = {
  class: "list_time"
};
import { ref, onMounted, computed } from "vue";
import { formatDateWithTZ } from "@/utils/format";
import StickyPowerBy from "@/components/StickyPowerBy.vue";
import EmptyListPlaceholder from "@/components/EmptyListPlaceholder.vue";
import { getUserActivity } from "@/api/activity";
import { ActivityStatusEnum } from "@/constant/activity";
import { useRememberScroll } from "@/hooks/useRememberScroll";
import { useActivityHistoryListStore } from "@/store/activityHistoryListStore";
import { getSupplyId } from "@/utils/authUtil";
import { useI18n } from "vue-i18n";
export default {
  __name: 'ActivityHistory',
  setup: function setup(__props) {
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var activityHistoryListStore = useActivityHistoryListStore();
    var _useRememberScroll = useRememberScroll("record-list", "activityHistoryListScrollTop", "setActivityHistoryListScrollTop"),
      rememberScrollPos = _useRememberScroll.rememberScrollPos,
      setScrollPos = _useRememberScroll.setScrollPos;
    rememberScrollPos();
    var statusText = _defineProperty(_defineProperty(_defineProperty({
      cancel: t("cancel")
    }, ActivityStatusEnum.ONGOING, t("onGoing")), ActivityStatusEnum.DONE, t("succeed")), ActivityStatusEnum.ENDED, t("failed"));
    var loading = ref(false);
    var pageSize = ref(10);
    var items = computed({
      get: function get() {
        return activityHistoryListStore.getList;
      },
      set: function set(val) {
        activityHistoryListStore.setList(val);
      }
    });
    var pageNum = computed({
      get: function get() {
        return activityHistoryListStore.getPageNum;
      },
      set: function set(val) {
        activityHistoryListStore.setPageNum(val);
      }
    });
    var finished = computed({
      get: function get() {
        return activityHistoryListStore.getFinished;
      },
      set: function set(val) {
        activityHistoryListStore.setFinished(val);
      }
    });
    var fetchData = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res, _res$data, data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              loading.value = true;
              _context.next = 3;
              return getUserActivity({
                page_num: pageNum.value,
                page_size: pageSize.value
              });
            case 3:
              res = _context.sent;
              loading.value = false;
              if (res.isOK) {
                data = ((_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.items) || [];
                if (data.length > 0) {
                  items.value = items.value.concat(data);
                  pageNum.value += 1;
                } else {
                  finished.value = true;
                }
              } else {
                finished.value = true;
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function fetchData() {
        return _ref.apply(this, arguments);
      };
    }();
    onMounted(function () {
      // if (items.value.length) {
      //   setScrollPos();
      // } else {
      activityHistoryListStore.resetState();
      fetchData();
      // }
    });
    function goDetail(item) {
      if (item.activity_type === "sharing") {
        location.href = "".concat(window.location.origin, "/activity/").concat(getSupplyId(), "/share?id=").concat(item.activity_id, "&user_activity_id=").concat(item.user_activity_id);
      }
    }
    return function (_ctx, _cache) {
      var _component_van_list = _resolveComponent("van-list");
      var _component_Page = _resolveComponent("Page");
      return _openBlock(), _createBlock(_component_Page, {
        title: _ctx.$t('activityHistory'),
        class: "activity-history"
      }, {
        default: _withCtx(function () {
          return [_createVNode(StickyPowerBy, {
            class: "activity-list"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_van_list, {
                id: "record-list",
                loading: loading.value,
                "onUpdate:loading": _cache[0] || (_cache[0] = function ($event) {
                  return loading.value = $event;
                }),
                finished: finished.value,
                "loading-text": _ctx.$t('loading'),
                class: "list",
                onLoad: fetchData
              }, {
                default: _withCtx(function () {
                  return [finished.value && items.value.length === 0 ? (_openBlock(), _createBlock(EmptyListPlaceholder, {
                    key: 0,
                    text: _ctx.$t('youHaveNoActivityYet'),
                    class: "empty"
                  }, null, 8, ["text"])) : _createCommentVNode("", true), items.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, function (item, index) {
                    return _openBlock(), _createElementBlock("div", {
                      key: item.id,
                      class: _normalizeClass(["list_item", {
                        'last-child': index === items.value.length - 1
                      }]),
                      onClick: function onClick($event) {
                        return goDetail(item);
                      }
                    }, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(formatDateWithTZ)(item.start_time)), 1)]), _createElementVNode("div", {
                      class: _normalizeClass(["list_value", _defineProperty({}, item.user_activity_status, true)])
                    }, _toDisplayString(statusText[item.user_activity_status]), 3)], 10, _hoisted_2);
                  }), 128))])) : _createCommentVNode("", true)];
                }),
                _: 1
              }, 8, ["loading", "finished", "loading-text"])];
            }),
            _: 1
          })];
        }),
        _: 1
      }, 8, ["title"]);
    };
  }
};